<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Incident Note Form</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #form="ngForm" (ngSubmit)="onSubmit()">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Value</mat-label>
      <textarea
        matInput
        placeholder="Value"
        [(ngModel)]="note.value"
        name="description"
        type="text"
        rows="10"
        cols="30"
        required
      ></textarea>
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">
    <button
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="submit"
      class="my-2 ml-1 mr-2"
      id="save">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      type="button"
      mat-icon-button
      color="warn"
      [disabled]="!note.id"
      class="dialog-remove-button my-2 ml-auto mr-1"
      matTooltip="Delete this Note"
      (click)="onDelete()">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-dialog-actions>
</form>
